/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react'
import { PUBLISH_REPORT_CONFIG, RELATIVE_DATE, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useTranslation } from '../../locale/useTranslation';
import BossDialog from '../../components/BossDialog';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { ConfirmDeleteAlert } from '../../ConfirmAlert';
import DeleteRoundButton from '../../framework/forms/helpercomponents/buttons/DeleteRoundButton';
import EditRoundButton from '../../framework/forms/helpercomponents/buttons/EditRoundButton';
import SaveButton from '../../framework/forms/helpercomponents/buttons/SaveButton';
import CancelButton from '../../framework/forms/helpercomponents/buttons/CancelButton';
import { utility } from '../../framework/utility/utilityProvider';
import { TimeRangePicker } from '../../framework/forms/helpercomponents/timepicker/TimeRangePicker';
import { TimeCell } from '../../framework/forms/helpercomponents/CustomGridCells/TimeCell';
import { EnumCell, SIDEnumCell } from '../../framework/forms/helpercomponents/CustomGridCells/EnumCell';
import ToastNotification from '../../components/ToastNotification';

const ChannelPublishEpgConfigEditForm = (props) => {
    const { publishData = [], setPublishData, onSavePublishData } = props;
    const lang = useTranslation();

    const blankDataItem = {
        ReportTypeConfig: {},
        RelativeStartDate: {},
        StartTime: "00:00",
        PublishingDays: "",
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [editMode, setEditMode] = useState(false);
    const [toggle, setToggle] = useState(false);
    const [relativeStartDates, setRelativeStartDates] = useState([]);

    const selectedIndexRef = useRef(null);

    useEffect(() => {
        loadcombo();
    }, [])

    const loadcombo = async () => {
        const relativeStartDateRes = Object.keys(RELATIVE_DATE).map((x) => {
            return { _id: RELATIVE_DATE[x], Description: x}
        })
        setRelativeStartDates(relativeStartDateRes);
    }

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    };

    const isValid = () => {

        if (!dataItem?.ReportTypeConfig || !dataItem?.ReportTypeConfig?.SID) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_report_type_error_message });
            return false;
        }
        return true;
    };
    const handleSaveData = () => {
        if (!isValid()) return;

        const payload = {
            ReportTypeConfig: dataItem?.ReportTypeConfig?.SID ?? null,
            RelativeStartDate: dataItem?.RelativeStartDate?._id ?? null,
            StartTime: dataItem?.StartTime ? utility.convertShortTimeStringToMilliSeconds(dataItem?.StartTime) : null,
            PublishingDays: dataItem?.PublishingDays ? parseInt(dataItem?.PublishingDays) : null
        };

        const updated = [...publishData];

        if (editMode) { updated[selectedIndexRef.current] = payload; }
        else { updated.push(payload); }

        onSavePublishData(updated);
        clearForm();
    };
    const editPublish = (props) => {

        selectedIndexRef.current = props?.dataIndex;
        setDataItem({
            ReportTypeConfig: props?.dataItem?.ReportTypeConfig ? PUBLISH_REPORT_CONFIG.find(x => x.SID === props?.dataItem.ReportTypeConfig) : {},
            RelativeStartDate: props?.dataItem?.RelativeStartDate ? { _id: props?.dataItem?.RelativeStartDate, Description: utility.getKeyByValue(RELATIVE_DATE, props?.dataItem?.RelativeStartDate) } : null,
            StartTime: utility.convertMilisecondsToShortTimeString(props?.dataItem?.StartTime),
            PublishingDays: props?.dataItem?.PublishingDays
        });
        setEditMode(true);
        setToggle(true);
    };

    const removePublish = (index) => {
        setPublishData((publishData || []).filter((_, i) => i !== index));
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.delete_successfully_grid_data_success_toast_message });
    };
    const clearForm = () => {
        setDataItem(blankDataItem);
        setEditMode(false);
        setToggle(false);
        selectedIndexRef.current = null;
    };
    const CommandCell = (props) => (
        <div className="d-flex gap-1 mt-1">
            <EditRoundButton onClick={() => editPublish(props)} />
            <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => removePublish(props.dataIndex), () => { })} />
        </div>
    );

    const ReportTypeCell = (props) => {
        const report = PUBLISH_REPORT_CONFIG.find(x => x.SID === props.dataItem.ReportTypeConfig);
        return (<td> {report ? report.Description : ""} </td>);
    };

    return (
        <div style={{ height: "100%", backgroundColor: "#EEEEEE", borderRadius: "10px", padding: "10px 20px 20px 20px" }}>
            <div className="row">
                <div className="col-12">
                    <AddRoundButton style={{ marginBottom: "5px" }} onClick={() => setToggle(true)} />
                    <Grid data={publishData} style={{ height: "40vh" }} resizable={true}  >
                        <GridColumn width="90px" title={lang.action_label} cell={CommandCell} locked />
                        <GridColumn field="ReportTypeConfig" title={lang.report_type_config_column} editable={false} cell={ReportTypeCell} width="150px" />
                        <GridColumn field="RelativeStartDate" title={lang.relative_start_date_column} editable={false} cell={EnumCell} width="150px" />
                        <GridColumn field="PublishingDays" title={lang.publishing_days_column} editable={false} width="150px" />
                        <GridColumn field="StartTime" title={lang.start_time_column} editable={false}  width="150px" cell={TimeCell}/>
                    </Grid>
                </div>
                {toggle && (<BossDialog title={lang.publish_label} onClose={clearForm} width={700}>
                    <div className="row">
                        <div className="col-12">
                            <div className="row">
                                <div className="marlr">
                                    {!editMode && (<SaveButton title="Add" onClick={handleSaveData} />)}
                                    {editMode && (<SaveButton title="Save" onClick={handleSaveData} />)}
                                    <CancelButton onClick={clearForm} />
                                </div>
                            </div>
                            <div className="mt-2">
                                <div className="row">
                                    <div className="col-12">
                                        <label htmlFor="TabView"> {lang.report_type_config_label} *</label>
                                        <DropDownList
                                            style={{ backgroundColor: "white" }}
                                            data={PUBLISH_REPORT_CONFIG.filter(x => x.isAutomate)}
                                            name="ReportTypeConfig"
                                            textField="Description"
                                            dataItemKey="SID"
                                            value={dataItem.ReportTypeConfig}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-6">
                                        <label>{lang.relative_start_date_label} </label>
                                        <DropDownList
                                            style={{ backgroundColor: "white" }}
                                            data={relativeStartDates}
                                            name="RelativeStartDate"
                                            textField="Description"
                                            dataItemKey="_id"
                                            value={dataItem.RelativeStartDate}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <label>{lang.start_time_label}</label>
                                        <TimeRangePicker
                                            name="StartTime"
                                            value={dataItem.StartTime}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                <div className='row mt-2'>
                                    <div className="col-6">
                                        <label>{lang.publishing_days_label}</label>
                                        <input
                                            type="number"
                                            name="PublishingDays"
                                            className="form-control form-control-sm"
                                            value={dataItem.PublishingDays}
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </BossDialog>
                )}
            </div>
        </div>
    );

}

export default ChannelPublishEpgConfigEditForm;